import React, { useState, useEffect, useCallback } from "react";
import { useMemo, useRef } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { Formik, Form } from "formik";
import { GridToolbarExport } from "@mui/x-data-grid";
import * as Yup from "yup";
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import SearchIcon from "@material-ui/icons/Search";
import { CloseOutlined } from "@material-ui/icons/";
import { saveAs } from 'file-saver';
import FileSaver from 'file-saver';
import Papa from 'papaparse';

const columns = [

    {
        field: "title",
        headerName: "ProductName",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 260,
        renderCell: (params) => (
            <Tooltip title={params.row.title} >
                <span className="table-cell-trucate">{params.row.title}</span>
            </Tooltip>
        )
    },
];




function useApiRef() {
    const apiRef = useRef(null);
    const _columns = useMemo(
        () =>

            columns.concat({
                field: "__HIDDEN__",
                width: 0,
                renderCell: (params) => {
                    apiRef.current = params.api;
                    return null;
                },
            }),
        [columns]
    );
    return { apiRef, columns: _columns };
}



const CreatePriceList = (props, excelData, filename) => {
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [cellchanged, setCellchanged] = React.useState([]);
    const [rows, setRows] = useState([]);
    const [row, setRow] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [ValideUpTo, setValideUpTo] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const { apiRef, columns } = useApiRef();
    const [DisablPer, setDisablPer] = useState(false);
    const [arr, setarr] = useState([]);
    const [Mode, setMode] = useState("");
    const [Per, setPer] = useState("");
    const [response, fetchData] = UseFetchData();
    const [ProductListresponse, FetchProductListData] = UseFetchData();
    const [ProductID, setProductID] = useState("");
    // const fs = require('fs');
    // const jsonData = require('./data.json');
    // const [columns, setColumns] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    const [data, setData] = useState([]);


    useEffect(() => {
        // debugger;
        setRows(ProductListresponse);
    }, [ProductListresponse]);



    const onSubmit = async () => {
        // debugger;
        try {
            // let gridcolumns = apiRef.current.getRowModels();
            var newSelection = selectionModel;
            let Div = 100;
            var ids = "";
            let DivCount = (Per / Div)
            if (selectionModel.length > 0) {
                for (var i = 0; i < newSelection.length; i++) {
                    ids = newSelection.join("','");

                    var bodyFormData = new FormData();
                    bodyFormData.append("ProductID", ids);
                    bodyFormData.append("Per", DivCount);
                    bodyFormData.append("ValideUpTo", ValideUpTo);
                    fetchData("product/PriceListExport", bodyFormData);

                }
            }
            else {
                alert("Please Select Product To Export");
            }
        }
        catch (error) {
            console.log(error);
        }
    };



    useEffect(() => {
        // debugger;
        if (response !== undefined && response.length > 0) {
            let iterator = response;
            handleExport(iterator);
        }

    }, [response]);


    useEffect(() => {
        // debugger;
        if (isChecked) {
            setDisablPer(false);
        } else {
            setDisablPer(true);
        }
    }, [isChecked]);

    const handleExport = (iterator) => {
        const csv = Papa.unparse(iterator);
        const blob = new Blob([csv], { 'Content-Type': 'text/csv/xlsx; charset=utf-8' });
        FileSaver.saveAs(blob, 'ProPL.csv');
    };


    useEffect(() => {
        PopulateData();
    }, []);

    const PopulateData = () => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", ProductID);
        FetchProductListData("product/PriceList", bodyFormData);
    };


    const handleCellEditCommit = React.useCallback(
        ({ id, field, value }) => {
            setCellchanged(value)
            if (field === "Amount") {
                // debugger;
                const [Quantity, Rate] = value.toString().split(" ");
                const updatedRows = rows.map((row) => {
                    if (row.id === id) {
                        return { ...row, Quantity, Rate };
                    }
                    return row;
                });
                setRows(updatedRows);
            }
        },
        [rows]
    );


    // useEffect(() => {
    //    // debugger;
    //     // setRow(selectionModel);
    //     if (selectionModel.length > 0) {
    //         let gridcolumns = apiRef.current.getRowModels();
    //         let iterator = gridcolumns;
    //         let data = Array.from(iterator);
    //         data = Object.values(data);
    //         data = Object.keys(data).map(key => (data[key][1]))
    //         const filterOptions = selectionModel;
    //         let result = data.filter(function (e) {
    //             return filterOptions.includes(e.id)
    //         });
    //         setRow(result);
    //     }
    // }, [selectionModel, cellchanged]);


    return (
        <Grid xs={12}>
            <Formik
                initialValues={{ ValideUpTo: ValideUpTo, Per: Per }}
                // validationSchema={validationSchema}
                // onSubmit={onSubmit}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <Form>
                            <Grid item Xs={8} spacing={2} container direction="row" xs={12}>
                                <Grid item xs={1}>
                                    <input
                                        type="checkbox"
                                        name="chkbox"
                                        checked={isChecked}
                                        onChange={(e) => {
                                            setIsChecked(e.target.checked);
                                        }}
                                    >
                                    </input>
                                </Grid>
                                <Grid item xs={3} style={{ marginRight: 70 }}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="Number"
                                        name="Per"
                                        disabled={DisablPer}
                                        onChange={(e) => setPer(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1} style={{ marginRight: 35 }}>
                                    <label
                                        htmlFor={"ValideUpTo"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"ValideUpTo"}
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="date"
                                        name="ValideUpTo"
                                        // disabled={true}
                                        onChange={(e) => setValideUpTo(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={2} container direction="row">
                                <Grid xs={12}>
                                    <BiztranControls.DataGrid
                                        rowHeight={25}
                                        rows={rows}
                                        columns={columns}
                                        // hideFooterPagination={false}
                                        checkboxSelection
                                        disableSelectionOnClick
                                        onSelectionModelChange={(newSelection) => {
                                            setSelectionModel(newSelection);
                                        }}
                                        onCellEditCommit={handleCellEditCommit}
                                        Height="340px"
                                        Width="100%"
                                    // components={{ Toolbar: CustomToolbar, }}
                                    />
                                </Grid>
                                <Grid xs={12} style={{ marginTop: 7 }}>
                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",
                                            }}
                                        >
                                            <BiztranControls.Button
                                                text="Export"
                                                startIcon={<SaveIcon />}
                                                style={{ marginTop: "0%" }}
                                                onClick={() => {
                                                    onSubmit();
                                                    // handleExport();
                                                }}
                                            />
                                            {isExporting && <p>Exporting...</p>}

                                            {/* <BiztranControls.Button
                                                text="Close"
                                                startIcon={<CloseOutlined />}
                                                style={{ marginTop: "0%" }}
                                                onClick={() => props.setOpen(false)}
                                            /> */}
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </Grid>
    );
};

export default CreatePriceList;
